var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"screening-flag-icon"},[(_vm.exclusion)?_c('b-tooltip',{attrs:{"label":"Flagged for exclusion"}},[_vm._v("\n    🚩\n  ")]):_vm._e(),_vm._v(" "),(_vm.inclusion)?_c('b-tooltip',{attrs:{"label":"Flagged for inclusion"}},[_vm._v("\n    ✅\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }